import { render, staticRenderFns } from "./GOODS_two_column_fullbleed.vue?vue&type=template&id=e1c57558&"
import script from "./GOODS_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./GOODS_two_column_fullbleed.vue?vue&type=script&lang=js&"
import style0 from "./GOODS_two_column_fullbleed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports